export function positionHoverMenu(element) {
  const MIN_LEFT_OFFSET = 10;
  const domSelection = window.getSelection();
  const domRange = domSelection.getRangeAt(0);
  const rect = domRange.getBoundingClientRect();

  let leftOffset = rect.left + window.pageXOffset - element.offsetWidth / 2 + rect.width / 2;

  if (leftOffset < MIN_LEFT_OFFSET) {
    leftOffset = MIN_LEFT_OFFSET;
  }

  element.style.opacity = "1";
  element.style.top = `${rect.top + window.pageYOffset - element.offsetHeight}px`;
  element.style.left = `${leftOffset}px`;
}
